<template>
	<v-card class="ma-2" v-if="offers.length > 0">

		<v-toolbar color="blue" dark>
			<v-toolbar-title>
				<v-icon class="mr-3">folder_shared</v-icon>
				Oferty współdzielone z innymi Oferentami
			</v-toolbar-title>
			<v-spacer></v-spacer>
		</v-toolbar>

		<v-list two-line>
			<template v-for="(offerAcceptance) in mutualOffers">
				<v-list-tile :key="offerAcceptance.id" avatar>
					<v-list-tile-avatar>
						<v-icon
							:color="getStatusIconColor(offerAcceptance)"
						>
							{{getStatusIcon(offerAcceptance)}}
						</v-icon>
					</v-list-tile-avatar>

					<v-list-tile-content>
						<v-list-tile-title> {{offerAcceptance.offerData.title}} 
						</v-list-tile-title>
						<v-list-tile-sub-title
							v-html="displayDateTime(offerAcceptance.creationDate)"></v-list-tile-sub-title>
						<v-list-tile-action-text v-html="getStatusText(offerAcceptance)"></v-list-tile-action-text>
					</v-list-tile-content>

					<v-list-tile-action>
						<egranty-icon-button
							icon="send"
							color="primary lighten-1"
							label="Zaakceptuj"
							for="mutual-offers-list-accept"
							id="mutual-offers-list-accept"
							@click="acceptOffer(offerAcceptance.offerData.id)"
							:disabled="offerAcceptance.accepted
								|| (offerAcceptance.offerData.offer.offerStatus !== 'AWAITING_MUTUAL_BIDDERS_ACCEPTANCE'
								&& offerAcceptance.offerData.offer.offerStatus !== 'POST_CORRECTION_MUTUAL')"/>
					</v-list-tile-action>
					<v-list-tile-action>
						<egranty-icon-button
							icon="close"
							color="primary lighten-1"
							label="Odrzuć"
							for="mutual-offers-list-reject"
							id="mutual-offers-list-reject"
							@click="rejectOffer(offerAcceptance.offerData.id)"
							:disabled="offerAcceptance.accepted
								|| (offerAcceptance.offerData.offer.offerStatus !== 'AWAITING_MUTUAL_BIDDERS_ACCEPTANCE'
								&& offerAcceptance.offerData.offer.offerStatus !== 'POST_CORRECTION_MUTUAL')"/>
					</v-list-tile-action>

					<v-list-tile-action>
						<egranty-icon-button
							icon="description"
							color="secondary lighten-1"
							label="Podgląd"
							for="mutual-offers-list-preview"
							id="mutual-offers-list-preview"
							@click="viewOffer(offerAcceptance.offerData.offer.id)"/>
					</v-list-tile-action>
				</v-list-tile>
			</template>
		</v-list>
		<egranty-error-list-popup
			title="Nie udało się wysłać oferty:"
			:error-list="sendOfferErrors.messages"
			:is-open="sendOfferErrors.showPopup"
			@close="sendOfferErrors.showPopup = false"
		/>
	</v-card>
</template>

<script>
	import EgrantyIconButton from "../../../../genericComponents/EgrantyIconButton";
	import {Dates} from "@/utils/Dates";
	import {Offer} from "@/api/generated/Offer";
	import EgrantyErrorListPopup from "../../../../genericComponents/EgrantyErrorListPopup";

	export default {
		name: "MutualOffersList",

		components: {EgrantyErrorListPopup, EgrantyIconButton},

		props: {
			offers: Array,
			contestId: String,
			placingOfferAllowed: Boolean,
		},

		data() {
			return {
				mutualOffers: [],
				sendOfferErrors: {
					showPopup: false,
					messages: [],
				},
			};
		},

		watch: {
			offers: {
				immediate: true,
				handler(val) {
					if (val === undefined) {
						val = [];
					}
					this.mutualOffers = val;
				},
			},
		},

		mixins: [
			Dates,
		],

		methods: {
			acceptOffer(offerDataId) {
				Offer.postAccept(this, offerDataId,
					successResponse => {
						this.$emit("refresh");
						this.$messagesBus.$emit("success", "Oferta została przez Ciebie zaakceptowana", successResponse);
					},
					errorResponse => {
            this.sendOfferErrors.messages = errorResponse.message.split("\n");
            if (this.sendOfferErrors.messages && this.sendOfferErrors.messages[0] === "OFFER_LIMIT_EXCEEDED") {
              this.sendOfferErrors.messages.shift();
              let errors = this.sendOfferErrors.messages.map(message => message.concat(": przekroczono limit ofert."));
              if (errors.length) {
                this.sendOfferErrors.messages = errors;
                this.sendOfferErrors.showPopup = true;
              }
              this.$messagesBus.$emit("error", "Przekroczono limit ofert w tym konkursie", errorResponse);
            } else {
              this.sendOfferErrors.messages.pop();
              if (this.sendOfferErrors.messages.length) {
                this.sendOfferErrors.showPopup = true;
              }
              this.$messagesBus.$emit("error", "Nie udało się zaakceptować oferty", errorResponse);
            }
					});
			},

			rejectOffer(offerDataId) {
				Offer.postRejectMutualOffer(this, offerDataId,
					successResponse => {
						this.$emit("refresh");
						this.$messagesBus.$emit("success", "Oferta została odrzucona", successResponse);
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się odrzucić oferty", errorResponse);
					});
			},

			viewOffer(offerId) {
				this.$router.openInNewTab("/view/contest/" + this.contestId + "/offer/" + offerId);
			},


			getStatusText(offerAcceptance){
				if(offerAcceptance.offerData.offer.offerProcessed){
					return "Oferta opiniowana";
				}
				return this.getDefaultStatusMessage(offerAcceptance);
			},

			getDefaultStatusMessage(offerAcceptance) {
				switch (offerAcceptance.offerData.offer.offerStatus) {
					case "NEW":
					case "AWAITING_MAIN_BIDDER_ACCEPTANCE":
						return "Oferta w trakcie uzupełniania";
					case "AWAITING_MUTUAL_BIDDERS_ACCEPTANCE":
					case "POST_CORRECTION_MUTUAL":
						if (!offerAcceptance.accepted) {
							return "Oferta oczekuje na potwierdzenie";
						} else {
							return "Oferta oczekuje na potwierdzenie innych współoferentów";
						}
					case "SUBMITTED":
						return "Oferta wysłana";
					case "REJECTED":
						return "Oferta odrzucona: " + offerAcceptance.offerData.offer.rejectCause;
					case "AWAITING_CORRECTION":
						return "Oferta oczekuje na poprawki: " + offerAcceptance.correctionCause;
					case "FINANCED":
						return "Oferta finansowana";
					case "NOT_FINANCED":
						return "Oferta niefinansowana";
					case "APPROVED":
						return "Oferta realizowana";
					case "RESERVED":
						return "Oferta rezerwowa";
				}
			},

			getStatusIcon(offerAcceptance) {
				switch (offerAcceptance.offerData.offer.offerStatus) {
					case "NEW":
					case "AWAITING_MAIN_BIDDER_ACCEPTANCE":
						return "help";
					case "AWAITING_MUTUAL_BIDDERS_ACCEPTANCE":
					case "POST_CORRECTION_MUTUAL":
						if (!offerAcceptance.accepted) {
							return "help";
						} else {
							return "check_circle";
						}
					case "SUBMITTED":
					case "RESERVED":
					case "NOT_FINANCED":
						return "check";
					case "REJECTED":
						return "block";
					case "FINANCED":
						return "star";
					case "APPROVED":
						return "stars";
					case "AWAITING_CORRECTION":
						return "build";
				}

			},

			getStatusIconColor(offerAcceptance) {
				switch (offerAcceptance.offerData.offer.offerStatus) {
					case "NEW":
					case "AWAITING_MAIN_BIDDER_ACCEPTANCE":
						return "grey";
					case "AWAITING_MUTUAL_BIDDERS_ACCEPTANCE":
					case "POST_CORRECTION_MUTUAL":
						return "amber";
					case "SUBMITTED":
					case "NOT_FINANCED":
						return "green";
					case "REJECTED":
						return "red";
					case "AWAITING_CORRECTION":
						return "grey";
					case "FINANCED":
					case "RESERVED":
						return "blue";
					case "APPROVED":
						return "green";
				}
			},
		},
	};
</script>

<style scoped>

</style>
